import './polyfill';
import '../public-path';

import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';

import { createBrowserHistory } from 'history';
import configureStore from 'store';

import { ApiClientProvider } from '@travel/api-client';
import { getDeviceType } from '@travel/traveler-core/utils';
import UIComponentContext from '@travel/ui/contexts';

import { createApiClient } from 'core/httpClient';
import commonErrorHandler from 'core/httpClient/commonErrorHandler';
import requestInterceptor from 'core/httpClient/requestInterceptor';
import responseInterceptor from 'core/httpClient/responseInterceptor';
import universalRouter from 'core/universalRouter';
import { Link } from 'core/universalRouter/Link';
import Router from 'core/universalRouter/Router';

const apiClient = createApiClient();

const history = createBrowserHistory({
  basename: window.PRELOADED_STATE.router.baseUrl,
});
const ssrDeviceType = getDeviceType(window.PRELOADED_STATE.userAgent);
const store = configureStore(window.PRELOADED_STATE, history, undefined, undefined, apiClient);

apiClient.setRequestInterceptor(requestInterceptor(store));
apiClient.setResponseInterceptor(responseInterceptor(store));
apiClient.setCommonErrorHandler(commonErrorHandler(store));

// Initialize the app
(async () => {
  const router = universalRouter({ store });
  const children = await router.resolve({
    ...history.location,
    skipResolver: true,
  });

  hydrateRoot(
    document.getElementById('root') as HTMLElement,
    <HelmetProvider>
      <UIComponentContext.Provider
        value={{
          ssrDeviceType,
          LinkComponent: ({ href, children, ...rest }) => (
            <Link to={href || ''} {...rest}>
              {children}
            </Link>
          ),
        }}
      >
        <ApiClientProvider apiClient={apiClient}>
          <ReduxProvider store={store}>
            <Router history={history} router={router}>
              {children}
            </Router>
          </ReduxProvider>
        </ApiClientProvider>
      </UIComponentContext.Provider>
    </HelmetProvider>,
  );
})();
